import type { Messages } from '@olxpwa-lib/i18n/client';
import type { Locale } from '@olxpwa-lib/i18n/types';

const MAP_LOCALE_TO_ISO_LANG: Record<Locale, string> = {
  'pl-PL': 'pl',
  'ro-RO': 'ro',
  'uk-UA': 'uk',
  'ru-UA': 'ru_uk',
  'kk-KZ': 'kk',
  'ru-KZ': 'ru_uk', // russian in lokalise has ru_uk code for some reason
  'bg-BG': 'en', // untranslated
  'pt-PT': 'en', // untranslated
  'uz-UZ': 'en', // untranslated
  'ru-UZ': 'en', // untranslated
};

export function makeMessagesLoader(e2eMode: boolean): (locale: string) => Promise<Messages> {
  const forcedIsoLang = e2eMode ? window.sessionStorage.getItem('__force_iso_lang__') : null;

  return (locale: string) => {
    const isoLang = forcedIsoLang || MAP_LOCALE_TO_ISO_LANG[locale as Locale] || 'en';

    return import(`./translations/${isoLang}.json`).then((module) => module.default);
  };
}
